import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, BreadcrumbsProps, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import { AppTypography } from './app-typography';

// ----------------------------------------------------------------------

type TLink = {
  href?: string;
  name: string;
  icon?: ReactElement;
};

export interface Props extends BreadcrumbsProps {
  links: TLink[];
  activeLast?: boolean;
}

export default function Breadcrumbs({ links, activeLast = false, ...other }: Props) {
  const currentLink = links[links.length - 1].name;

  const listDefault = links.map((link) => <LinkItem key={link.name} link={link} />);

  const listActiveLast = links.map((link, idx) => (
    <div key={idx}>
      {link.name !== currentLink ? (
        <LinkItem link={link} />
      ) : (
        <AppTypography variant="body2" color="primary">
          {currentLink}
        </AppTypography>
      )}
    </div>
  ));

  return (
    <MUIBreadcrumbs
      separator={
        <Box
          component="span"
          sx={{ width: 4, height: 4, bgcolor: '#999594' }}
        />
      }
      {...other}
    >
      {activeLast ? listDefault : listActiveLast}
    </MUIBreadcrumbs>
  );
}

// ----------------------------------------------------------------------

type LinkItemProps = {
  link: TLink;
};

function LinkItem({ link }: LinkItemProps) {
  const { href, name, icon } = link;
  return (
    <Link
      key={name}
      variant="body2"
      component={RouterLink}
      to={href || '#'}
      className={!href ? 'disabled' : ''}
      sx={{
        lineHeight: 2,
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        color: '#999594',
        '& > div': { display: 'inherit' },
        ...(!href && {
          pointerEvents: 'none',
          cursor: 'text',
        }),
        '&:hover': {
          fontWeight: 800,
          textDecoration: 'none',
        }
      }}
    >
      {icon && <Box sx={{ mr: 1, '& svg': { width: 20, height: 20 } }}>{icon}</Box>}
      {name}
    </Link>
  );
}
